import { __assign, __generator } from "tslib";
import { request } from '../../xhr';
import { put, call } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { getGallectionType } from '../helpers';
import { normalizeDeviation, normalizeGallection, } from '../../redux/normalizr/helpers';
function setGallectionCover(_a) {
    var updatedGallection, entities, params;
    var _b;
    var gallection = _a.gallection, deviation = _a.deviation, _c = _a.onlyIfMissing, onlyIfMissing = _c === void 0 ? false : _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (onlyIfMissing && gallection.thumb) {
                    return [2 /*return*/];
                }
                // stash doesn't support custom covers
                if (gallection.type === 'stash') {
                    return [2 /*return*/];
                }
                if (![DeviationTypes.IMAGE, DeviationTypes.LITERATURE].includes(getDeviationType(deviation))) {
                    // Only allow images and literature deviations as gallection covers
                    return [2 /*return*/];
                }
                updatedGallection = __assign(__assign({}, gallection), { thumb: deviation });
                entities = normalizeGallection(updatedGallection);
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 1:
                _d.sent();
                params = {
                    type: (_b = getGallectionType(gallection)) !== null && _b !== void 0 ? _b : 'collection',
                    folderid: gallection.folderId,
                    name: gallection.name,
                    description: gallection.description || '',
                    cover_deviationid: deviation.deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update',
                        data: params,
                    })];
            case 2:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export function setGallectionCoverActionHandler(action) {
    var _a, gallection, deviation, entities;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, gallection = _a.gallection, deviation = _a.deviation;
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: gallection,
                        deviation: deviation,
                    })];
            case 1:
                _b.sent();
                entities = normalizeDeviation(deviation);
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionCover;
//# sourceMappingURL=setGallectionCover.js.map